<template>
  <div>
    <van-button @click="show=true" size="small">
      <slot>
        <span v-if="$attrs.value">{{ valueMap[$attrs.value] }}</span>
        <span v-else style="color: orange">请选择</span>
      </slot>
    </van-button>
    <van-popup v-model="show" position="bottom" style="height: 40%" round>
      <van-picker
        show-toolbar
        v-bind="$attrs"
        v-on="$listeners"
        v-loading="loading"
        :columns="options_"
        @cancel="show=false"
        @confirm="confirm"/>
    </van-popup>
  </div>
</template>

<script>
import { Picker, Popup, Button } from 'vant'

export default {
  name: 'RemoteVanSelect',
  components: {
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Button.name]: Button
  },
  props: {
    className: String,
    options: Array,
    selectFirst: {
      type: Boolean,
      default: false
    },
    removeSet: Set,
    usingCode: Boolean,
    selectAll: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      show: false
    }
  },
  created () {
    if (this.options) return
    this.$store.dispatch('data/kvList', this.className)
  },
  methods: {
    confirm (item) {
      this.$emit('input', item.value)
      this.show = false
    }
  },
  computed: {
    options_ () {
      if (this.options) return this.options

      const options = []
      if (this.selectAll) {
        options.push({
          text: '全部',
          value: null
        })
      }
      const usingCode = this.usingCode
      for (const item of this.$store.state.data[this.className] || []) {
        if (this.removeSet && this.removeSet.has(item.id)) continue

        options.push({ text: item.name, value: usingCode ? item.code : item.id })
      }
      return options
    },
    valueMap () {
      const ret = {}
      for (const item of this.options_) {
        ret[item.value] = item.text
      }
      return ret
    }
  }
}
</script>

<style scoped>
</style>
